
define(
	'Tavano.TT_PaymentHoldOn.MessageOnHold'
	, [
		'Tavano.TT_PaymentHoldOn.MessageOnHold.View'
	]
	, function (
		MessageOnHoldView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				var layout = container.getComponent('Layout');
				var checkout = container.getComponent('Checkout');

				if (layout) {
					container.getComponent('UserProfile').getUserProfile().done(function (userprofile) {
						if (userprofile && userprofile.isloggedin && layout) {
							if (!userprofile.creditholdoverride && !checkout) {
								layout.addChildView('Payment.Message.OnHold', function () {
									return new MessageOnHoldView({ container: container });
								});
							} else if (!userprofile.creditholdoverride && checkout) {
								// If the user is logged in and has a credit hold override, we don't want to show the continue button
								// and we want to show the message on the checkout page
								layout.addToViewContextDefinition('OrderWizard.Step', 'showContinueButton', 'boolean', function (context) {
									return false;
								});

								layout.addChildView('Payment.Message.OnHold', function () {
									return new MessageOnHoldView({ container: container });
								});
							}
						} else {

							console.log('User is not logged in');
						}
					});
				}

			}
		};
	});
